<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <situacion-laboral-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import SituacionLaboralCrud from "./SituacionLaboralCrud";
    export default {
        name: "SituacionLaboral",
        components: {SituacionLaboralCrud}
    }
</script>

<style scoped>

</style>

